export const Ib = (a) => {
  if (typeof a === 'undefined') {
    return
  }
  const b = a.rect
  const c = b.width || 1e-5
  const d = b.height || 1e-5
  const p1 = a.toGlobal({
    x: b.x,
    y: b.y
  })
  const p2 = a.toGlobal({
    x: b.x + c,
    y: b.y
  })
  const p3 = a.toGlobal({
    x: b.x + c,
    y: b.y + d
  })
  const p4 = a.toGlobal({
    x: b.x,
    y: b.y + d
  })
  return [p1, p2, p3, p4]
}
